export const formatPercentage = (fraction) => {
  return fraction === undefined || fraction === null ? '' : `${(fraction * 100).toFixed(2)}%`;
};
